const features = [
  {
    img: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/ad2ebddcda783eaa112a176327089ceb.png',
    title: 'Easy Deposit & Withdrawal',
    desc: 'Move money in and out in PGK with straightforward steps and familiar local banking. Clear limits, quick processing, and your balance always easy to track.',
  },
  {
    img: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/6a1fd36274eeb719a596a1776a4013d0.png',
    title: 'Wide Varieties Games',
    desc: 'A deep library from leading studios — classics, new releases, and high-volatility favourites — so you can switch styles without leaving the platform.',
  },
  {
    img: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/fd56a3279358e23a99240a5b0255543e.png',
    title: '24/7 Customer Service',
    desc: 'Real people, round the clock. Ask about payments, bonuses, or your account — get clear answers fast, any time of day.',
  },
  {
    img: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/5ca53f48cb1c92420522ecd416a18db9.png',
    title: 'Most Trusted Platform',
    desc: 'Built for Papua New Guinea players: fair play, secure accounts, and a brand that treats your trust as the product — not an afterthought.',
  },
];

export default function FeaturesSection() {
  return (
    <section className="bg-[#111] py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((f, i) => (
            <div
              key={i}
              className="bg-[#1a1a1a] rounded-xl p-6 flex flex-col items-center text-center border border-white/5 hover:border-[#B80E28]/30 transition-all duration-300 group"
            >
              <div className="w-20 h-20 flex items-center justify-center mb-4">
                <img src={f.img} alt={f.title} className="w-16 h-16 object-contain group-hover:scale-110 transition-transform duration-300" />
              </div>
              <h3 className="text-[#B80E28] font-bold text-base mb-3">{f.title}</h3>
              <p className="text-white/60 text-sm leading-6">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
